import SelectableCardGroup from './common/SelectableCardGroup';

const OPTIONS = [
  {
    key: 'fixed',
    title: '예식 일정이 거의 정해졌어요',
    desc: '예복 맞춤 일정을 구체적으로 계획할 수 있어요',
    icon: 'ri-calendar-check-line',
  },
  {
    key: 'adjusting',
    title: '날짜 조율 중이에요',
    desc: '대략적인 시즌은 정했지만 세부 날짜는 유동적이에요',
    icon: 'ri-calendar-event-line',
  },
  {
    key: 'started',
    title: '이제 막 준비 시작했어요',
    desc: '아직 여유롭게 기준을 잡아볼 단계예요',
    icon: 'ri-seedling-line',
  },
];

interface StepStageProps {
  value: string | null;
  onChange: (val: string) => void;
}

export default function StepStage({ value, onChange }: StepStageProps) {
  return <SelectableCardGroup options={OPTIONS} value={value} onChange={onChange} />;
}
